import React, { useState } from 'react';
import {
  Modal, Input, Button, Alert, Typography, Space, message,
} from 'antd';
import { useDispatch } from 'react-redux';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import { useAdminVerifyOtp } from '../../../../hooks/api/admins';
import { actions } from '../../../../store/auth';
import store from '../../../../store';

const { Text, Title } = Typography;

interface TwoFASetupModalProps {
  visible: boolean;
  qrCode: string | undefined | null;
  secret: string | undefined | null;
  loading?: boolean;
  error?: string | null;
}

export default function TwoFASetupModal({
  visible,
  qrCode,
  secret,
  loading = false,
  error = null,
}: TwoFASetupModalProps) {
  const adminVerifyOtp = useAdminVerifyOtp();

  const dispatch = useDispatch();
  const [code, setCode] = useState('');

  const handleVerify = () => {
    if (code.length === 6) {
      adminVerifyOtp.fetch({ code })
        .then((res) => {
          // res?.access && res.refresh
          if (!!res && 'access' in res && 'refresh' in res && (res?.access && res.refresh)) {
            dispatch(actions.updateTokensSuccess({
              access: res.access,
              refresh: res.refresh,
            }));
            // dispatch(refreshToken());

            // setTimeout(() => navigate('/'), 100);
            // setTimeout(() => window.location.reload(), 100);
          }
          if (!!res && 'secret' in res) {
            message.error('Invalid 2FA code or something went wrong');
          }
        })
        .catch(() => {
          message.error('Invalid 2FA code or something went wrong');
        });
    }
  };

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleCancel = () => {
    // If user canceled out, force boot them completely back to login
    store.dispatch(signOut());
    // dispatch(signOut());
    window.location.reload();
  };

  return (
    <Modal
      title={(
        <Title level={4}>
          {secret ? 'Set Up' : 'Proceed with'}
          {' '}
          Two-Factor Authentication (2FA)
        </Title>
)}
      open={visible}
      closable={false}
      centered
      maskClosable={false}
      footer={[
        <Button key="logout" onClick={handleCancel}>
          Cancel & Sign Out
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={code.length !== 6}
          loading={loading || adminVerifyOtp.loading}
          onClick={handleVerify}
        >
          {secret ? 'Verify & Save' : 'Continue'}
        </Button>,
      ]}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%', textAlign: 'center' }}>
        {qrCode && (
          <>
            <Text type="secondary">
              Scan this QR code with your Authenticator App (Google Authenticator, Duo, etc.) to set up 2FA.
            </Text>
            <div style={{ margin: '16px 0' }}>
              <img
                src={qrCode}
                alt="2FA QR Code"
                style={{ border: '1px solid #f0f0f0', padding: '8px', borderRadius: '4px' }}
              />
            </div>
          </>
        )}

        {secret && (
          <div style={{
            textAlign: 'left', background: '#f5f5f5', padding: '12px', borderRadius: '4px',
          }}
          >
            <Text strong>Can&apos;t scan the QR code?</Text>
            <Text type="secondary"> Enter this secret key manually into your app:</Text>
            <br />
            <Text code copyable style={{ fontSize: '14px', letterSpacing: '1px' }}>{secret}</Text>
          </div>
        )}

        <div style={{ textAlign: 'left', marginTop: '8px' }}>
          <Text strong>Enter the 6-digit verification code:</Text>
          <Input
            maxLength={6}
            placeholder="000000"
            size="large"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} // only allow digits
            onPressEnter={handleVerify}
            style={{
              textAlign: 'center', letterSpacing: '4px', fontSize: '18px', marginTop: '8px',
            }}
          />
        </div>

        {error && (
          <Alert message={error} type="error" showIcon style={{ textAlign: 'left' }} />
        )}
      </Space>
    </Modal>
  );
}
